import $ from '@modules/jquery-import';
import Swiper from 'swiper/bundle';

$( async () => {

    $( () => {

        var swiper = new Swiper( '.my-swiperCarousel', {
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 1,

            loop: $( '.swiper-slide' ).length > 1 ? true : false,
            loopFillGroupWithBlank: false,
            watchOverflow: true, // This checks if there's only one slide and disables swiper if true
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        } );

        $( '.my-swiperCarousel' ).mouseenter( function () {
            swiper.autoplay.pause();
        } );

        $( '.my-swiperCarousel' ).mouseleave( function () {
            swiper.autoplay.paused == true ? swiper.autoplay.resume() : swiper.autoplay.stop();
        } );

        $( '.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet, .button' ).click( function () {
            swiper.autoplay.stop();
        } );

    } )

} )